import {Button, Col, Row, Tooltip} from 'antd';
import {ColumnsType} from 'antd/lib/table/Table';
import {RiDeleteBin5Line, RiEdit2Line} from 'react-icons/ri';
import {useIntl} from 'react-intl';
import IntlMessages from '../../../../../../../domain/utility/IntlMessages';
import {AttributesOptionListDto} from '../../../../../../../shared/services/specification-attribute/dto/attributes-option-dto';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

const TableColumn = (
  handleClickOnUpdate: (value: any) => void,
  deleteAttributeOption: (value: any) => void,
): ColumnsType<any> => {
  const {messages} = useIntl();

  const {locale}: any = useLocaleContext();

  return [
    {
      title: <IntlMessages id='specificationAttributes.edit.optionName' />,
      dataIndex: 'Name',
      key: 'Name',
      width: '60%',
      render: (value: string, record: AttributesOptionListDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: (
        <IntlMessages id='specificationAttributes.edit.optionDisplayOrder' />
      ),
      dataIndex: 'DisplayOrder',
      key: 'DisplayOrder',
      className: 'col-num',
      width: '20%',
    },
    {
      title: <IntlMessages id='common.Action' />,
      key: 'action',
      render: (value, record: AttributesOptionListDto, index) => {
        return (
          <Row justify='center'>
            <Col>
              <Tooltip
                title={messages[
                  'tooltip.specificationAttributes.edit.editOption'
                ].toString()}>
                <Button
                  onClick={() => handleClickOnUpdate(record)}
                  type='link'
                  icon={<RiEdit2Line />}
                />
              </Tooltip>
            </Col>

            <Col>
              <Tooltip
                title={messages[
                  'tooltip.specificationAttributes.edit.removeOption'
                ].toString()}>
                <Button
                  onClick={() => deleteAttributeOption(record)}
                  icon={<RiDeleteBin5Line className='removeIcon' />}
                  type='link'
                  danger
                />
              </Tooltip>
            </Col>
          </Row>
        );
      },
      className: 'col-actions',
      width: 100,
      ellipsis: true,
    },
  ];
};

export default TableColumn;
